<p>report-logview works!</p>
